<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="header text-center">
            <h4 class="title">Create New Campaign</h4>
          </div>
          <create-campaign-form :selectedDrivers="selectedDrivers" @removeDriver="removeDriver" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <card>
            <div class="header">
              <h4 class="title">Filter Drivers</h4>
            </div>
            <div v-if="drivers && drivers.length" class="table-responsive">
              <form>
                <div class="row">
                  <div class="col-md-4">
                    <base-input type="text"
                              label="Name"
                              placeholder="Name"
                              v-model="driverNameFilter">
                    </base-input>
                  </div>
                  <div class="col-md-4">
                    <base-input type="text"
                              label="Tag"
                              placeholder="Tag"
                              v-model="driverTagFilter">
                    </base-input>
                  </div>
                  <div class="col-md-4">
                    <base-input type="text"
                              label="Team"
                              placeholder="Team"
                              v-model="driverTeamFilter">
                    </base-input>
                  </div>
                </div>
              </form>
              <d-table class="table-hover" :columns="columns" :data="filteredDrivers" @selectDriver="selectDriver"></d-table>
            </div>
            <p v-else-if="loading" class="card-category">Loading Drivers...</p>
            <p v-else class="card-category">No Drivers found...</p>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import { getApp } from 'firebase/app';
  import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";

  import CreateCampaignForm from './Campaigns/CreateCampaignForm.vue';
  import DTable from 'src/components/DriversTable.vue';
  import Card from 'src/components/Cards/Card.vue'

  export default {
    components: {
      CreateCampaignForm,
      DTable,
      Card,
    },
    data () {
      return {
        loading: false,
        columns: ['Name', 'Fleet ID', 'Tags', 'Team'],
        drivers: [],
        driverNameFilter: '',
        driverTagFilter: '',
        driverTeamFilter: '',
        selectedDrivers: [],
      }
    },
    computed: {
      filteredDrivers() {
        return this.drivers.filter(item => {
          const nameMatch = this.driverNameFilter ? item.name.toLowerCase().includes(this.driverNameFilter.toLowerCase()) : true;
          const tagsMatch = this.driverTagFilter ? item.tags && item.tags.toLowerCase().includes(this.driverTagFilter.toLowerCase()) : true;
          const teamIdMatch = this.driverTeamFilter ? item.team_id && item.team_id.toString().includes(this.driverTeamFilter.toString()) : true;

          return nameMatch && tagsMatch && teamIdMatch;
        });
      }
    },
    async created() {
      const app = getApp()
      const functions = getFunctions(app, 'europe-west1')
      // connectFunctionsEmulator(functions, "127.0.0.1", 5001);
      const getDrivers = httpsCallable(functions, 'getDrivers');
      const getDriversRes = await getDrivers();
      this.drivers = getDriversRes.data.data;
    },
    methods: {
      selectDriver(fleet_id) {
        let currentDrivers = this.selectedDrivers;
        currentDrivers.push(fleet_id);
        Vue.set(this, 'selectedDrivers', [...new Set(currentDrivers)]);
      },
      removeDriver(index) {
        let currentDrivers = this.selectedDrivers;
        currentDrivers.splice(index, 1)
        Vue.set(this, 'selectedDrivers', [...new Set(currentDrivers)]);
      }
    },
  }

</script>
<style>

</style>
